import React from "react";
import { Route } from "react-router-dom";
import Dashboard from "./Dashboard";
import UploadFile from "./UploadFile";
import ReportList from "./Report/Reports/ReportList";
import AssetsCreditRisk from "./Report/AssetsCreditRisk";
import Rwa from "./Report/RWA";
import FileManagement from "./FileManagement/FileManagement";

export default function Raroc({ match }) {
  return (
    <div className="content">
      <div className="container-fluid">
        <Route path={`${match.url}/dashboard`} component={Dashboard} />
        <Route path={`${match.url}/upload-file`} component={UploadFile} />
        <Route path={`${match.url}/reports`} exact component={ReportList} />
        <Route
          path={`${match.url}/reports/assets-credit-risk`}
          component={AssetsCreditRisk}
        />
        <Route path={`${match.url}/reports/rwa`} component={Rwa} />
        <Route
          path={`${match.url}/file-management`}
          component={FileManagement}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// src/pages/Raroc/index.js